$(document).ready(function(){
  $('.product-upsell').click(function() {
    $( this ).toggleClass( 'active' );
  });
  $('#product-form').submit(function(){
    $('#product-form').first().find('.product-upsell').each(function() {
      var variantId = parseInt($(this).attr('data-product-id'));
      if($(this).hasClass('active')) { 
        jQuery.ajax({
          type: "POST",
          url: '/cart/add.js',
          data: {
            quantity: 1,
            id: variantId
          },
          async: false
        });         
      } 

    });
    return true;
  });
});